import React from 'react';
import styles from './troy.module.scss';

import DocumentPage from '../../components/common/DocumentPage/index.troy';
import { getImpressum } from '../../store/actions';
import { connectTo } from '../../utils';

class ConfidentialityPage extends React.Component {
  componentDidMount() {
    const { getImpressum } = this.props;
    getImpressum();
  }

  render() {
    const { html } = this.props;
    return <DocumentPage {...{ styles, html }} />;
  }
}

export default connectTo(
  ({
    wordpress: {
      impressum: { content }
    }
  }) => ({
    html: content
  }),
  { getImpressum },
  ConfidentialityPage
);
